export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7710.edc55e74.jpg";